export default __webpack_public_path__ + "static/media/poor-icon.7bfd2e60.svg";